








































import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class InterviewCard extends Vue {
  @Prop({ default: "" })
  readonly oid!: string;
  @Prop({ default: "" })
  readonly iid!: string;
  @Prop({ default: "" })
  readonly name!: string;
  @Prop({ default: "red-pastel" })
  readonly color!: string;
  @Prop({ default: false })
  readonly available!: boolean;

  getIconUrl() {
    const images = require.context('../assets/icons/', false, /\.png$/);
    return images('./' + this.slugify(this.name) + '.png')
  }
  
  slugify(str: string) {
    str = str.replace(/^\s+|\s+$/g, '');

    // Make the string lowercase
    str = str.toLowerCase();

    // Remove accents, swap ñ for n, etc
    const from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    const to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (let i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    // Remove invalid chars
    str = str.replace(/[^a-z0-9 -]/g, '') 
    // Collapse whitespace and replace by -
    .replace(/\s+/g, '-') 
    // Collapse dashes
    .replace(/-+/g, '-'); 

    return str;
  }
}
